const Grid = {
  order: Infinity,
  run($$) {
    return $$.$.on("seats:rendered", () => {
      const $canvas = $('<canvas id="seatsGrid" />')
        .attr({
          width: $$.seatsWidth + "px",
          height: $$.seatsHeight + "px",
        })
        .css({
          top: 0,
          left: 0,
          width: $$.seatsWidth,
          height: $$.seatsHeight,
          boxShadow: "2px 2px 0 #efefef",
        })
        .appendTo($$.$arena.find(".seats-container"))[0];

      const context = $canvas.getContext("2d");

      let x = 0.5 + $$.SEAT_WIDTH;
      while (x < $$.seatsWidth) {
        context.moveTo(x, 0);
        context.lineTo(x, $$.seatsHeight);
        x += $$.SEAT_WIDTH;
      }

      let y = 0.5 + $$.SEAT_HEIGHT;
      while (y < $$.seatsHeight) {
        context.moveTo(0, y);
        context.lineTo($$.seatsWidth, y);
        y += $$.SEAT_HEIGHT;
      }

      context.strokeStyle = "#d1d0c5";
      context.stroke();
    });
  },
};

window.SectionGrid = Grid;

export default Grid;
